export default function MenuSerializer(data){
    if(data)
    return {
        id: data.menu_id,
        name: data.menu_name,
        domain: data.domain_id,
        parent: data.parent_menu_id,
        level: data.level_id,
        active: data.is_active,
        blob: data.blob_path,
        index: data.index_name,
        qnaFaqs: data.qna_faqs,
        docsearchFaqs: data.docsearch_faqs,
        insertDate: data.date_of_insert,
        insertUser: data.user_of_insert,
        changeDate: data.date_of_change,
        changeUser: data.user_of_change,
    }
    return null
}